(function () {
  "use strict";
  const eyeOpenSvg = `
    <svg class="customer-field-eye-icon eye-open" viewBox="0 0 24 24">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="4"/>
    </svg>`;
  const eyeClosedSvg = `
    <svg class="customer-field-eye-icon eye-closed hidden" viewBox="0 0 24 24">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a4 4 0 1 1-5.66-5.66"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>`;

  const setupEye = () => {
    const passwordField = document.querySelector(
      '.cf-field [data-cf-column-key="password"]'
    );
    if (!passwordField) return;

    const hasToggle = passwordField.parentNode.querySelector(
      ".customer-field-password-toggle"
    );
    if (hasToggle) return;

    passwordField.parentNode.classList.add("customer-field-password-container");

    const toggleButton = document.createElement("button");
    toggleButton.type = "button";
    toggleButton.className = "customer-field-password-toggle";
    toggleButton.setAttribute("aria-label", "Show/Hide password");
    if ("it" === Shopify.locale)
      toggleButton.setAttribute("aria-label", "Mostra/Nascondi password");
    toggleButton.setAttribute("tabindex", "-1");

    toggleButton.innerHTML = [eyeOpenSvg, eyeClosedSvg].join("");

    toggleButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const eyeOpen = toggleButton.querySelector(".eye-open");
      const eyeClosed = toggleButton.querySelector(".eye-closed");

      if ("password" === passwordField.type) {
        // Show password
        passwordField.type = "text";
        eyeOpen.classList.add("hidden");
        eyeClosed.classList.remove("hidden");
      } else {
        // Hide password
        passwordField.type = "password";
        eyeOpen.classList.remove("hidden");
        eyeClosed.classList.add("hidden");
      }
    });

    passwordField.parentNode.appendChild(toggleButton);
  };

  for (const e of ["cf:ready", "DOMContentLoaded"])
    window.addEventListener(e, setupEye);
})();
